import { apiClient } from '../../../shared/api/client.js';
import type { NotificationItem } from '../../../shared/types/index.js';

export const notificationsApi = {
  async getNotifications(): Promise<{ notifications: NotificationItem[]; unreadCount: number }> {
    return apiClient('/api/notifications');
  },

  async markAsRead(id: string): Promise<void> {
    return apiClient(`/api/notifications/${id}/read`, { method: 'PATCH' });
  },

  async markAllRead(): Promise<void> {
    return apiClient('/api/notifications/read-all', { method: 'POST' });
  },

  async triggerTestPush(): Promise<{ success: boolean; notification: NotificationItem }> {
    return apiClient('/api/notifications/test-push', { method: 'POST' });
  },

  async deleteNotification(id: string): Promise<void> {
    return apiClient(`/api/notifications/${id}`, { method: 'DELETE' });
  },

  async deleteReadNotifications(): Promise<void> {
    return apiClient('/api/notifications/delete-read', { method: 'POST' });
  },
};
